import React, {Component} from 'react';
import {LoaderSmall} from '../../../loader';

class AudioViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            audioUrl: null,
        };
        this.abortController = null;
    }

    componentDidMount() {
        this.fetchAudio();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filePath !== this.props.filePath) {
            this.fetchAudio();
        }
    }

    componentWillUnmount() {
        this.abortController?.abort();
        this.revokeAudioUrl();
    }

    // Backend doesn't reliably support Range requests, so fetch the whole file up front and seek locally.
    fetchAudio() {
        this.abortController?.abort();
        this.abortController = new AbortController();

        this.setState({loading: true});

        fetch(this.props.filePath, {signal: this.abortController.signal})
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch audio file');
                }
                return response.blob();
            })
            .then(blob => {
                const audioUrl = URL.createObjectURL(blob);
                this.revokeAudioUrl();
                this.setState({audioUrl});
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return;
                }
                this.setState({loading: false});
                this.props.onError?.(error);
            });
    }

    revokeAudioUrl() {
        if (this.state.audioUrl) {
            URL.revokeObjectURL(this.state.audioUrl);
        }
    }

    onCanPlay() {
        this.setState({loading: false});
    }

    render() {
        const {loading, audioUrl} = this.state;
        const visibility = loading ? 'hidden' : 'visible';

        return (
            <div className="pg-driver-view">
                <div className="video-container">
                    {loading && (
                        <LoaderSmall disableContainer={true}/>
                    )}

                    <audio
                        style={{visibility}}
                        controls
                        controlsList="nodownload"
                        onCanPlay={e => this.onCanPlay(e)}
                        src={audioUrl || undefined}
                    >
                        Audio playback is not supported by your browser.
                    </audio>
                </div>
            </div>
        );
    }
}

export default AudioViewer;
